import * as MutationsType from "./mutationsType";

/* eslint-disable no-param-reassign */
export default {
  [MutationsType.SET_BACKUP](state, payload) {
    state.backup = payload;
  },
};
